import { Component, OnInit, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from "@angular/common";
import {AlertService, IAlertType} from '../../_shared/services';
import {ClrAlertModule, ClrIconModule} from "@clr/angular";
import { AuthService } from "../../_shared/services/auth.service";
import { catchError, of } from "rxjs";
import {ClarityIcons, heartBrokenIcon, heartIcon} from "@cds/core/icon";

@Component({
  selector: 'app-alert',
  standalone: true,
  imports: [
    CommonModule,
    ClrAlertModule,
    ClrIconModule
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  templateUrl: './alert.component.html',
  styleUrl: './alert.component.sass'
})
export class AlertComponent implements OnInit {
  public alertIcon = 'info-circle';
  public alertMessage = 'App Level Alert';
  public alertColor= '{ alert-info }';
  public crmMode = false;
  public crmHealthy: boolean | null = null;

  constructor(
    public alertService: AlertService,
    private authService: AuthService
  ) {
    ClarityIcons.addIcons(heartIcon, heartBrokenIcon)
  }

  ngOnInit(): void {
    this.crmMode = this.authService.crmMode;
    if (!this.crmMode) {
      return;
    }

    this.authService.cmsAuthHealthCheck()
      .pipe(catchError(() => of(false)))
      .subscribe((ok: boolean) => {
        this.crmHealthy = ok === true;
      });
  }

  get isAlertClosable(): boolean {
    return this.alertService.alertConfig.clrAlertClosable ?? true; // Fallback-Wert: true
  }
  get appLevel(): boolean {
    return this.alertService.alertConfig.clrAlertAppLevel ?? true; // Fallback-Wert: true
  }

  get alertType(): string {
    return this.alertService.alertConfig.clrAlertType ?? IAlertType.WARNING; // Fallback-Wert setzen
  }

  get showCrmStatus(): boolean {
    const message = this.alertService.alertConfig.message ?? '';
    return this.crmMode && this.crmHealthy !== null && message.includes('All engines running');
  }
}
